module.exports = "/src/views/player/captures/assets/bell.svg";